<template>
  <!-- mall -->
  <div>
    <!-- 移动端 -->
    <div v-if="isPC === false" class="mobile-layout">
      <index-header></index-header>
      <keep-alive>
        <router-view v-if="$route.meta.isKeep"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.isKeep"></router-view>
      <Footer v-if="!hiddenFooter($route.path)" />
    </div>
    <!-- PC端 -->
    <div v-else class="layout">
      <index-header />
      <div :style="{ paddingTop: isScroll ? '115px' : $store.state.isShowAdvertis ? '163px' : '113px' }">
        <keep-alive>
          <router-view v-if="$route.meta.isKeep"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.isKeep"></router-view>
        <!-- <router-view /> -->
      </div>
      <Footer v-if="!hiddenFooter($route.path)" />
    </div>
  </div>
</template>

<script>
// import Header from '../mobile/Header.vue'
import Header1 from '@/views/index/components/Header.vue'
import Footer from '@/views/home/components/Footer.vue'
// import API from '@/api'

export default {
  data() {
    return {
      isScroll: false,
      hiddenFooterRouteList: [
        '/product-list',
        '/mall/new-in',
        '/mall/sale',
        '/mall/discount',
        '/mall/explore',
        '/product-detail',
        '/mall/similar',
        '/confirm-order',
        '/payment-status',
        '/customizedAdd',
        '/customizedSuccess',
        '/mall/category-detail',
        '/mall/explore/detail',
        '/mall/album',
        '/mall/flash-sale',
        '/mall/festival-collection',
        '/404',
        '/mall/mobileCart'
      ]
    }
  },
  components: {
    // Header,
    'index-header': Header1,
    Footer
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    hiddenFooter(path) {
      if (path.charAt(path.length - 1) === '/') {
        path = path.substring(0, path.length - 1)
      }
      if (path.includes('/product-detail') || path.includes('/product-list')) {
        return true
      }
      return this.hiddenFooterRouteList.includes(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
}

// 移动端
.mobile-layout {
  padding-top: 75px;
}
</style>
